import { render, staticRenderFns } from "./InvestorAboutYouData.vue?vue&type=template&id=a4e2d18a&scoped=true&"
import script from "./InvestorAboutYouData.vue?vue&type=script&lang=js&"
export * from "./InvestorAboutYouData.vue?vue&type=script&lang=js&"
import style0 from "./InvestorAboutYouData.vue?vue&type=style&index=0&id=a4e2d18a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e2d18a",
  null
  
)

export default component.exports